import { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { isDateAvailableWithTableCheck } from '../../algorithm/isDateAvailableWithTableCheck';
import { checkYeatAvailability } from '../../TimeSelector/Utils/YeatHelpers';

export default function useSuggestedDates({
  restaurantData,
  reservations,
  displayedMonth,
  guests,
  giftcard,
}) {
  const [suggestedDates, setSuggestedDates] = useState([]);

  useEffect(() => {
    if (!restaurantData || !reservations || !displayedMonth) return;

    const today = moment().tz('Europe/Amsterdam').startOf('day');
    const monthStart = displayedMonth.clone().startOf('month');
    const monthEnd = displayedMonth.clone().endOf('month');
    const foundDates = [];

    let date = monthStart.clone();
    while (date.isSameOrBefore(monthEnd, 'day') && foundDates.length < 3) {
      const formattedDate = date.format('YYYY-MM-DD');
      let available = false;

      try {
        available = isDateAvailableWithTableCheck(
          restaurantData,
          formattedDate,
          reservations,
          guests,
          giftcard
        );

        if (!available) {
          available = checkYeatAvailability(reservations, formattedDate, guests);
        }
      } catch (error) {
        console.error('Error checking date availability:', error);
      }

      if (available && date.isSameOrAfter(today, 'day')) {
        foundDates.push(date.clone());
      }

      date.add(1, 'day');
    }

    setSuggestedDates(foundDates);
  }, [restaurantData, reservations, guests, displayedMonth, giftcard]);

  return suggestedDates;
}


